<template>
  <div
    :class="{
      [`${customizeData.theme}-theme`]: customizeData.theme,
      customizing: customize.isCustomizing,
    }"
    class="afripods-player"
  >
    <svg
      v-if="playerData.loading"
      class="player-loading"
      height="200px"
      preserveAspectRatio="xMidYMid"
      style="background: none"
      viewBox="0 0 100 100"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="75" cy="50" fill="#f2765d" r="6.39718">
        <animate
          attributeName="r"
          begin="-0.875s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="67.678" cy="67.678" fill="#f2765d" r="4.8">
        <animate
          attributeName="r"
          begin="-0.75s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="50" cy="75" fill="#f2765d" r="4.8">
        <animate
          attributeName="r"
          begin="-0.625s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="32.322" cy="67.678" fill="#f2765d" r="4.8">
        <animate
          attributeName="r"
          begin="-0.5s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="25" cy="50" fill="#f2765d" r="4.8">
        <animate
          attributeName="r"
          begin="-0.375s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="32.322" cy="32.322" fill="#f2765d" r="4.80282">
        <animate
          attributeName="r"
          begin="-0.25s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="50" cy="25" fill="#f2765d" r="6.40282">
        <animate
          attributeName="r"
          begin="-0.125s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
      <circle cx="67.678" cy="32.322" fill="#f2765d" r="7.99718">
        <animate
          attributeName="r"
          begin="0s"
          dur="1s"
          repeatCount="indefinite"
          times="0;0.1;0.2;0.3;1"
          values="4.8;4.8;8;4.8;4.8"
        />
      </circle>
    </svg>
    <div
      v-show="playerData.shouldShow && !playerData.loading"
      id="embedplayer"
      :class="{
        single: playlistData.episodes.length === 0,
        playlist: playlistData.episodes.length > 0,
        [`preview-${props.customize.previewMode}`]: customize.isCustomizing,
      }"
    >
      <section ref="playerWrapper" :class="{ 'no-image': !playerData.showImage }" class="player-wrapper">
        <div ref="episodeInfo" class="episode-info">
          <a v-if="playerData.showImage" :href="playerData.episodePageUrl" target="_blank">
            <div class="episode-image">
              <img :src="playerData.image" alt="Episode cover image" />
            </div>
          </a>
          <div ref="episodeText" class="episode-text">
            <div :class="{ scrolling: playerData.textMarquee }">
              <div ref="episodeTextWrapper">
                <a
                  ref="podcastName"
                  :href="playerData.podcastPageUrl"
                  :style="{ color: playerData.accentColor }"
                  class="podcast-name"
                  target="_blank"
                  >{{ playerData.podcastName }}
                </a>
                <a ref="episodeTitle" :href="playerData.episodePageUrl" class="episode-title" target="_blank"
                  >{{ playerData.title }}
                </a>
              </div>
              <div v-if="playerData.textMarquee">
                <a
                  :href="playerData.podcastPageUrl"
                  :style="{ color: playerData.accentColor }"
                  class="podcast-name"
                  target="_blank"
                  >{{ playerData.podcastName }}
                </a>
                <a
                  v-show="playerData.textMarquee"
                  :href="playerData.episodePageUrl"
                  class="episode-title"
                  target="_blank"
                  >{{ playerData.title }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="player-controls">
          <div class="player-progress">
            <div class="timestamps">
              <span :style="setPlayerPlayBackNumberStyle()" class="current-playback-time">{{
                secondsToTimestamp(playerData.sliderTime)
              }}</span>
              <div class="sliderwrap">
                <VueSlider
                  v-model="playerData.sliderTime"
                  :clickable="true"
                  :dot-style="{ backgroundColor: playerData.accentColor }"
                  :max="playerData.audioDurationSeconds"
                  :process-style="{ backgroundColor: playerData.accentColor }"
                  tooltip="none"
                  @change="sliderClick"
                  @click.native="sliderClick"
                  @drag-start="sliderDragStart"
                  @drag-end="sliderDragEnd"
                />
              </div>
              <span
                :style="playerData.audioDurationSeconds > 3600 ? 'min-width: 42px;' : ''"
                class="episode-duration"
                >{{ secondsToTimestamp(playerData.audioDurationSeconds) }}</span
              >
            </div>
          </div>
          <div class="button-group">
            <div class="playback-rate-slider">
              <div class="playback-rate-slider-wrap">
                <div class="slider-marks">
                  <span
                    v-for="playbackRate in PLAYBACK_RATE_PRESETS"
                    :key="playbackRate"
                    @click.prevent="playerData.playbackRate = playbackRate"
                    >{{ playbackRate }}x</span
                  >
                </div>
                <VueSlider
                  v-model="playerData.playbackRate"
                  :data="PLAYBACK_RATE_PRESETS"
                  :dot-style="{
                    backgroundColor: customizeData.theme === 'dark' ? '#fff' : '#000',
                  }"
                  :process-style="{
                    backgroundColor: customizeData.theme === 'dark' ? '#fff' : '#000',
                  }"
                  tooltip="none"
                />
              </div>
              <button id="playback-rate" @dblclick.prevent="playerData.playbackRate = 1">
                {{ playerData.playbackRate }}x
              </button>
            </div>
            <div class="rw-play-fw">
              <button id="rewind" @click.prevent="rewind(15)">
                <svg fill="currentColor" height="28" width="31">
                  <path
                    d="M14.677 10.85a.29.29 0 0 1 .127-.028h.774c.065 0 .098.032.098.097v6.622c0 .065-.033.098-.098.098h-.744c-.066 0-.098-.033-.098-.098v-5.716c0-.013-.007-.023-.02-.03-.006-.006-.016-.006-.03 0l-1.027.351a.11.11 0 0 1-.05.01c-.038 0-.061-.026-.068-.078l-.039-.555c0-.065.02-.104.059-.117l1.116-.555Zm6.359 3.77c.072.286.108.58.108.886 0 .305-.04.588-.117.847a1.81 1.81 0 0 1-.715.994c-.346.24-.76.36-1.244.36-.476 0-.884-.117-1.223-.35a1.85 1.85 0 0 1-.715-.955 1.68 1.68 0 0 1-.108-.477v-.02c0-.052.03-.078.088-.078h.774c.059 0 .091.03.098.088a1.6 1.6 0 0 0 .049.205c.072.24.196.431.372.574.183.137.401.205.656.205.267 0 .492-.072.675-.215.19-.149.317-.353.382-.613.046-.136.069-.325.069-.565 0-.214-.02-.412-.06-.594a.838.838 0 0 0-.352-.565c-.182-.136-.41-.204-.685-.204-.254 0-.483.058-.685.175a.769.769 0 0 0-.392.448c-.02.058-.055.088-.107.088h-.784c-.065 0-.098-.033-.098-.098V10.92c0-.065.033-.098.098-.098h3.662c.065 0 .098.033.098.098v.614c0 .064-.033.097-.098.097h-2.78c-.027 0-.04.013-.04.039l-.01 2.035c0 .04.017.049.05.03.156-.137.336-.238.538-.302.209-.072.427-.107.656-.107.457 0 .848.113 1.175.34.332.228.554.546.665.955Z"
                  />
                  <path
                    d="M14.966.137a14.14 14.14 0 0 1 8.77 1.61 14.028 14.028 0 0 1 6.035 6.531 13.933 13.933 0 0 1 .878 8.829 13.988 13.988 0 0 1-4.632 7.58 14.13 14.13 0 0 1-16.889.967 14.011 14.011 0 0 1-5.475-7.002c-.224-.634.11-1.33.748-1.553a1.225 1.225 0 0 1 1.56.744 11.574 11.574 0 0 0 4.524 5.784 11.671 11.671 0 0 0 13.951-.798 11.555 11.555 0 0 0 3.827-6.263 11.51 11.51 0 0 0-.726-7.293 11.588 11.588 0 0 0-4.986-5.395 11.678 11.678 0 0 0-7.244-1.33 11.648 11.648 0 0 0-6.62 3.293L4.312 9.929H9.79a1.22 1.22 0 0 1 1.224 1.217 1.22 1.22 0 0 1-1.224 1.218H1.224A1.22 1.22 0 0 1 0 11.146V2.624a1.22 1.22 0 0 1 1.224-1.217 1.22 1.22 0 0 1 1.224 1.217v5.708l4.55-4.253A14.1 14.1 0 0 1 14.965.137Z"
                  />
                </svg>
              </button>
              <button id="playPause" @click.prevent="playPause">
                <Transition name="fade-blur">
                  <svg v-show="playerData.paused" fill="currentColor" height="20" width="16">
                    <path
                      d="M.52.122A1 1 0 0 1 1.54.16l14 9a1 1 0 0 1 0 1.682l-14 9A1 1 0 0 1 0 19V1A1 1 0 0 1 .52.122Z"
                    />
                  </svg>
                </Transition>
                <Transition name="fade-blur">
                  <svg v-show="!playerData.paused" id="pause" fill="currentColor" height="20" width="18">
                    <path
                      d="M1.5 0A1.5 1.5 0 0 0 0 1.5v17A1.5 1.5 0 0 0 1.5 20h3A1.5 1.5 0 0 0 6 18.5v-17A1.5 1.5 0 0 0 4.5 0h-3ZM13 0a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-4Z"
                    />
                  </svg>
                </Transition>
              </button>
              <button id="forward" @click.prevent="forward(15)">
                <svg fill="currentColor" height="28" width="31">
                  <path
                    d="M10.593 10.861a.28.28 0 0 1 .128-.029h.773c.066 0 .098.032.098.097v6.623c0 .065-.033.097-.098.097h-.744c-.065 0-.098-.032-.098-.097v-5.717c0-.013-.006-.023-.02-.03-.006-.006-.016-.006-.029 0l-1.028.351a.11.11 0 0 1-.049.01c-.039 0-.062-.026-.068-.078l-.04-.555c0-.065.02-.104.06-.117l1.115-.555Zm6.36 3.769c.072.286.108.581.108.886 0 .306-.039.588-.117.848a1.81 1.81 0 0 1-.715.993c-.346.24-.76.36-1.244.36-.476 0-.884-.116-1.223-.35a1.85 1.85 0 0 1-.715-.954 1.68 1.68 0 0 1-.108-.478v-.02c0-.051.03-.077.088-.077h.774c.058 0 .091.03.098.088.006.045.022.113.049.204.071.24.195.432.372.575.182.136.401.204.656.204.267 0 .492-.071.675-.214.19-.15.317-.354.382-.614.046-.136.069-.324.069-.564 0-.215-.02-.413-.06-.595a.838.838 0 0 0-.352-.564c-.182-.137-.41-.205-.685-.205a1.34 1.34 0 0 0-.685.175.769.769 0 0 0-.392.448c-.02.059-.056.088-.108.088h-.783c-.065 0-.098-.032-.098-.097v-3.838c0-.065.033-.097.098-.097h3.662c.065 0 .098.032.098.097v.614c0 .065-.033.097-.098.097h-2.78c-.027 0-.04.013-.04.04l-.01 2.035c0 .039.017.049.05.029a1.51 1.51 0 0 1 .538-.302c.208-.071.427-.107.656-.107.457 0 .848.114 1.175.34.332.228.555.546.665.955ZM29.776 1.418A1.22 1.22 0 0 1 31 2.635v8.522a1.22 1.22 0 0 1-1.224 1.217H21.21a1.22 1.22 0 0 1-1.224-1.217 1.22 1.22 0 0 1 1.224-1.218h7.343V2.635a1.22 1.22 0 0 1 1.224-1.217Z"
                  />
                  <path
                    d="M15.708 2.55A11.68 11.68 0 0 0 8.46 3.871a11.589 11.589 0 0 0-4.993 5.39 11.509 11.509 0 0 0-.733 7.293 11.555 11.555 0 0 0 3.82 6.266 11.674 11.674 0 0 0 13.953.812 11.575 11.575 0 0 0 4.53-5.78 1.226 1.226 0 0 1 1.562-.743c.637.224.971.92.746 1.554a14.011 14.011 0 0 1-5.483 6.997 14.131 14.131 0 0 1-16.89-.983 13.987 13.987 0 0 1-4.625-7.585 13.931 13.931 0 0 1 .887-8.828A14.029 14.029 0 0 1 7.28 1.74a14.14 14.14 0 0 1 8.772-1.6 14.103 14.103 0 0 1 7.965 3.951l6.598 6.18c.492.461.516 1.232.052 1.721a1.229 1.229 0 0 1-1.73.052L22.326 5.85a11.65 11.65 0 0 0-6.618-3.301Z"
                  />
                </svg>
              </button>
            </div>
            <div class="volume-slider">
              <div class="volume-slider-wrap">
                <VueSlider
                  v-model="playerData.volume"
                  :clickable="true"
                  :direction="playerData.width < 600 ? 'btt' : 'ltr'"
                  :dot-style="{
                    backgroundColor: customizeData.theme === 'dark' ? '#fff' : '#000',
                  }"
                  :max="100"
                  :process-style="{
                    backgroundColor: customizeData.theme === 'dark' ? '#fff' : '#000',
                  }"
                  tooltip="none"
                  @change="volumeChange"
                />
              </div>
              <button
                id="volume"
                @dblclick.prevent="
                  () => {
                    playerData.volume = playerData.volume === 0 ? 100 : 0
                    volumeChange()
                  }
                "
              >
                <svg fill="currentColor" height="11" width="13">
                  <path
                    d="M10.247.203a.546.546 0 0 1 .85 0C12.315 1.608 13 3.513 13 5.5c0 1.987-.685 3.892-1.903 5.297a.546.546 0 0 1-.85 0 .769.769 0 0 1 0-.979C11.241 8.673 11.8 7.12 11.8 5.5c0-1.62-.558-3.173-1.552-4.318a.769.769 0 0 1 0-.98ZM6.171.116c.208.115.34.358.34.624v9.52c0 .266-.132.509-.34.624a.537.537 0 0 1-.636-.083L2.75 8.232H.6c-.331 0-.6-.31-.6-.692V3.46c0-.382.269-.692.6-.692h2.15L5.535.199a.537.537 0 0 1 .636-.083ZM5.31 2.18 3.335 4a.553.553 0 0 1-.375.152H1.2v2.696h1.76A.55.55 0 0 1 3.335 7L5.31 8.82V2.18Zm2.854.423a.546.546 0 0 1 .849 0c.666.768 1.04 1.808 1.04 2.894 0 1.085-.374 2.125-1.04 2.893a.546.546 0 0 1-.85 0 .769.769 0 0 1 0-.979c.441-.508.688-1.196.688-1.914s-.247-1.407-.687-1.915a.769.769 0 0 1 0-.979Z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <a href="https://afripods.africa" target="_blank">
          <div class="player-logo">
            <img alt="logo" src="/static/images/embedplayer/afripods-logo.svg" />
          </div>
        </a>
        <audio id="embed" ref="audioElement" preload="none" @ended="endEventListener" @timeupdate="timeupdate" />
      </section>

      <section
        v-if="playlistData.episodes.length > 0"
        ref="playlistWrapper"
        :class="{
          [`preview-${customize.previewMode}`]: customize.isCustomizing,
        }"
        class="playlist-wrapper"
      >
        <section class="playlist-title">
          <span>All Episodes</span>
          <label
            :class="
              playerData.width > 599
                ? `playlist-search expanded${playlistData.searchValue ? ' has-value' : ''}`
                : `playlist-search button${playlistData.searchValue ? ' has-value' : ''}`
            "
          >
            <svg fill="currentColor" height="13" width="13">
              <path
                d="M5.833 1a4.833 4.833 0 1 0 3.363 8.305.502.502 0 0 1 .109-.109A4.833 4.833 0 0 0 5.833 1Zm4.464 8.59a5.833 5.833 0 1 0-.707.707l2.556 2.557a.5.5 0 0 0 .708-.708L10.297 9.59Z"
                fill-rule="evenodd"
              />
            </svg>
            <input
              ref="playlistSearch"
              v-model="playlistData.searchValue"
              placeholder="Search episodes"
              type="search"
              @input="filterEpisodes"
            />
          </label>
        </section>
        <section v-if="playlistData.sorted" ref="playlistEpisodes" class="playlist-episodes">
          <article
            v-for="ep in playlistData.filteredEpisodes"
            :key="ep.id"
            :class="{ 'info-open': ep.open }"
            class="playlist-episode"
          >
            <div class="playlist-episode-top">
              <button
                :class="{ playing: ep.playing }"
                class="episode-play btn-unstyled"
                @click.prevent="loadEpisode(ep, true)"
              >
                <svg v-if="!ep.playing || playerData.paused" fill="currentColor" height="10" width="8">
                  <path
                    d="M.26.061a.5.5 0 0 1 .51.02l7 4.5a.5.5 0 0 1 0 .84l-7 4.5a.5.5 0 0 1-.77-.42v-9A.5.5 0 0 1 .26.06Z"
                  />
                </svg>
                <svg v-else id="pause" fill="currentColor" height="10" width="9">
                  <path
                    d="M.75 0A.75.75 0 0 0 0 .75v8.5a.75.75 0 0 0 .75.75h1.5A.75.75 0 0 0 3 9.25V.75A.75.75 0 0 0 2.25 0H.75ZM6.5 0a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-2Z"
                  />
                </svg>
              </button>
              <span class="playlist-episode-title">
                <span class="title"
                  ><a
                    v-dompurify-html="options.filters.highlightString(ep.title, playlistData.searchValue.trim())"
                    :href="ep.link"
                    target="_blank"
                /></span>
                <span class="show-more" @click.prevent="toggleEpisodeInfo(ep.playlistId)"
                  >{{ ep.open ? 'Hide info' : 'Show more info' }}
                  <svg fill="currentColor" height="9" width="5">
                    <path
                      d="M.146.146a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L3.793 4.5.146.854a.5.5 0 0 1 0-.708Z"
                    />
                  </svg>
                </span>
              </span>

              <span class="playlist-episode-duration">{{ secondsToTimestamp(ep.durationSeconds) }}</span>
            </div>
            <SmoothReflow
              :options="{
                transition: 'height 200ms',
              }"
            >
              <div
                v-show="ep.open"
                v-dompurify-html="options.filters.highlightString(ep.description, playlistData.searchValue.trim())"
                class="playlist-episode-description rich-text-content"
              />
            </SmoothReflow>
          </article>
          <div v-if="playlistData.filteredEpisodes.length === 0" class="no-filter-matches">
            No matches for <em>"{{ playlistData.searchValue.trim() }}"</em>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>

<script setup>
import debounce from 'lodash/debounce'
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { arrayOf, bool, number, oneOf, shape, string } from 'vue-types'

import SmoothReflow from 'components/reused-components/smooth-reflow/SmoothReflow'
import { getEpisodeImageURL, sortByISODateString } from 'utils'
import { StatisticsHelper } from 'utils/Statistics/StatisticsHelper'
import afripodsHttp from 'api/statistics/statistics'
import * as DataType from 'components/AudioPlayer/model/constants/DataType'
import * as ImpressionType from 'components/AudioPlayer/model/constants/ImpressionType'

const { $options: options, $router: router, $log: log } = getCurrentInstance().proxy

const props = defineProps({
  customize: shape({
    brandColor: string(),
    previewMode: oneOf(['', 'desktop', 'mobile']),
    isCustomizing: bool(),
    showCover: bool(),
    theme: oneOf(['light', 'dark']),
  }).loose.def({
    brandColor: '#f2765d',
    previewMode: '',
    isCustomizing: false,
    showCover: true,
    theme: 'light',
  }),
  episode: shape({
    description: string().isRequired,
    duration: number().isRequired,
    id: string().isRequired,
    image: string().isRequired,
    link: string().isRequired,
    podcast_id: string().isRequired,
    podcast_images: shape({
      cover: string().isRequired,
      main: string().isRequired,
    }).isRequired,
    podcast_title: string().isRequired,
    publish_date: string().isRequired,
    streamUrl: string().isRequired,
    title: string().isRequired,
  }).loose,
  episodes: arrayOf(
    shape({
      description: string().isRequired,
      duration: number().isRequired,
      id: string().isRequired,
      image: string().isRequired,
      link: string().isRequired,
      podcast_id: string().isRequired,
      podcast_images: shape({
        cover: string().isRequired,
        main: string().isRequired,
      }).isRequired,
      podcast_title: string().isRequired,
      publish_date: string().isRequired,
      streamUrl: string().isRequired,
      title: string().isRequired,
    }).loose
  ),
})

const PLAYBACK_RATE_PRESETS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3]

let playerCursorState = 'pointer'
const audioElement = ref(null)
const playlistSearch = ref(null)
const episodeTitle = ref(null)
const podcastName = ref(null)
const episodeText = ref(null)
const episodeInfo = ref(null)
const episodeTextWrapper = ref(null)
const playerWrapper = ref(null)
const aggregatedTimer = reactive({
  startTimeStamp: null,
  stopTimeStamp: null,
  timerDiff: null,
  aggregatedPlaySent: false,
  timer: null,
})
const streamTimer = reactive({
  startTimeMinutes: null,
  stopTimeMinutes: null,
})
const statisticObjects = ref([])

const playerData = reactive(
  /**
   * @type {{
   *   accentColor: string,
   *   audioDurationSeconds: number,
   *   audioFileUrl: string,
   *   currentPlaybackTime: number,
   *   episodePageUrl: string,
   *   image: string,
   *   loading: boolean,
   *   paused: boolean,
   *   playbackRate: number,
   *   podcastPageUrl: string,
   *   podcastName: string,
   *   shouldShow: boolean,
   *   showImage: boolean,
   *   sliderTime: number,
   *   textMarquee: boolean,
   *   title: string,
   *   volume: number,
   *   width: number
   * }}
   */
  {
    accentColor: '#f2765d',
    audioDurationSeconds: 0,
    audioFileUrl: '',
    currentPlaybackTime: 0,
    episodePageUrl: '',
    image: '/static/images/embedplayer/episode-placeholder.jpg',
    loading: false,
    paused: true,
    playbackRate: 1,
    podcastPageUrl: '',
    podcastName: '',
    shouldShow: false,
    showImage: true,
    sliderTime: 0,
    textMarquee: false,
    title: '',
    volume: 100,
    width: document.documentElement.clientWidth,
  }
)

watch(
  () => playerData.playbackRate,
  (playbackRate) => {
    audioElement.value.playbackRate = playbackRate
  }
)

const playlistData = reactive(
  /**
   * @type {{
   *   currentEpisode: object,
   *   episodes: object[],
   *   filteredEpisodes: object[],
   *   rawEpisodes: object,
   *   searchClass: string,
   *   searchValue: string,
   *   sorted: boolean
   * }}
   */
  {
    currentEpisode: {},
    episodes: [],
    filteredEpisodes: [],
    rawEpisodes: {},
    searchClass: 'playlist-search',
    searchValue: '',
    sorted: false,
  }
)
const customizeData = reactive({})

const secondsToTimestamp = (seconds) => {
  let formula = new Date(seconds * 1000).toISOString().slice(14, 19)
  if (seconds > 3600) {
    formula = new Date(seconds * 1000).toISOString().slice(11, 19)
  }

  return formula
}

const setPlayerPlayBackNumberStyle = () => {
  /**
   * Used to style the playback time so that it
   * does not overlap or jump when changing
   * and so that the colors in small versus large
   * players is correct.
   */
  const minDurationSeconds = 3599
  const maxDurationSeconds = 3600
  const minPlayerWidthDesktop = 599
  const maxPlayerWidthMobile = 600

  return playerData.audioDurationSeconds > minDurationSeconds && playerData.width < maxPlayerWidthMobile
    ? 'min-width: 38px;'
    : playerData.audioDurationSeconds > minDurationSeconds && playerData.width > minPlayerWidthDesktop
    ? `min-width: 38px;color:${playerData.accentColor};`
    : playerData.audioDurationSeconds < maxDurationSeconds && playerData.width > minPlayerWidthDesktop
    ? `color:${playerData.accentColor};`
    : ''
}

const calculateTextOverflow = () => {
  playerData.textMarquee = false

  if (episodeTitle.value) {
    let episodeTextWidth =
      playerData.width > 599
        ? episodeTitle.value.offsetWidth + 8 + podcastName.value.offsetWidth + 46
        : episodeTitle.value.offsetWidth > podcastName.value.offsetWidth
        ? episodeTitle.value.offsetWidth
        : podcastName.value.offsetWidth

    if (playerData.width < 600) {
      episodeTextWidth =
        episodeTitle.value.offsetWidth + podcastName.value.offsetWidth > episodeText.value.offsetWidth
          ? episodeTitle.value.offsetWidth + podcastName.value.offsetWidth
          : episodeTextWidth
    }

    // timeout to reset scroll animation before applying it again
    // eslint-disable-next-line no-return-assign
    setTimeout(() => (playerData.textMarquee = episodeTextWidth >= episodeText.value.offsetWidth), 0)
  }
}

const sendTrackingData = (statObject) => {
  afripodsHttp
    .createTrackingData(statObject)
    .then((response) => response)
    .catch((e) => log.debug('** Afripods error on sendTrackingData(): ', e))
}

const sendTrackingDataList = (statsList) => {
  if (!statsList || statsList.value.length === 0) return

  afripodsHttp
    .createListOfTrackingData(statsList.value)
    .then((response) => {
      if (response.status === 200) {
        statisticObjects.value = []
      }
    })
    .catch((e) => log.debug('** Afripods error on sendTrackingDataList(): ', e))
}

const trackEpisodeCompleteImpression = (episodeId) => {
  const stat = StatisticsHelper.episode(DataType.EPISODE, episodeId, ImpressionType.COMPLETE_IMPRESSION)
  sendTrackingData(stat)
}

const trackEpisodePlayImpression = () => {
  // Player has accumulated at least 60 seconds of playtime for episodeId
  const episodeId = props.episode?.id ?? playlistData.currentEpisode.id
  const stat = StatisticsHelper.episode(DataType.EPISODE, episodeId, ImpressionType.PLAY_IMPRESSION)

  sendTrackingData(stat)
  aggregatedTimer.aggregatedPlaySent = true
}

const calculateEpisodePlayTime = () => {
  const playtimeTarget = 60000 // number of seconds of playtime to send the impression
  let diff

  if (aggregatedTimer.aggregatedPlaySent) return

  if (aggregatedTimer.startTimeStamp === null) {
    aggregatedTimer.startTimeStamp = new Date()
    // New start timestamp
    if (aggregatedTimer.timerDiff === null) {
      // Starting first timer
      aggregatedTimer.timer = setTimeout(() => trackEpisodePlayImpression(), playtimeTarget)
    } else {
      const remaining = playtimeTarget - aggregatedTimer.timerDiff
      aggregatedTimer.stopTimeStamp = null
      clearTimeout(aggregatedTimer.timer)
      aggregatedTimer.timer = setTimeout(() => trackEpisodePlayImpression(), remaining)
    }
  } else if (aggregatedTimer.startTimeStamp !== null && aggregatedTimer.stopTimeStamp === null) {
    aggregatedTimer.stopTimeStamp = new Date()
    diff = aggregatedTimer.stopTimeStamp - aggregatedTimer.startTimeStamp
    let oldDiff = 0
    if (aggregatedTimer.timerDiff !== null) {
      oldDiff = aggregatedTimer.timerDiff
    }
    const newDiff = diff + oldDiff
    aggregatedTimer.timerDiff = newDiff
    aggregatedTimer.startTimeStamp = null
    clearTimeout(aggregatedTimer.timer)
  }
}

const resetTimers = () => {
  aggregatedTimer.timerDiff = null
  aggregatedTimer.startTimeStamp = null
  aggregatedTimer.stopTimeStamp = null
  aggregatedTimer.aggregatedPlaySent = false
  streamTimer.startTimeMinutes = null
  streamTimer.stopTimeMinutes = null
  clearTimeout(aggregatedTimer.timer)
}

const composeStreamImpression = (type) => {
  const start = streamTimer.startTimeMinutes
  const end = streamTimer.stopTimeMinutes
  const streamHasValidTimestamps = start !== end && start < end
  if (!streamHasValidTimestamps) return

  const episodeId = props.episode?.id ?? playlistData.currentEpisode.id

  const statsObject = StatisticsHelper.stream(
    DataType.STREAMDURATION,
    episodeId,
    ImpressionType.STREAM_IMPRESSION,
    start,
    end,
    type
  )

  statisticObjects.value.push(statsObject)
}

const playPause = () => {
  const currentPlayerTime = audioElement.value.currentTime
  if (audioElement.value.src) {
    calculateEpisodePlayTime()
    if (audioElement.value.paused) {
      audioElement.value.play()
      playerData.paused = false
      streamTimer.startTimeMinutes = Math.floor(currentPlayerTime / 60)
    } else {
      audioElement.value.pause()
      playerData.paused = true
      streamTimer.stopTimeMinutes = Math.floor(currentPlayerTime / 60)
      composeStreamImpression(DataType.STREAM)
    }
  }
}

const setWidth = () => {
  playerData.width =
    props.customize.previewMode === 'mobile' ? playerWrapper.value.offsetWidth : document.documentElement.clientWidth
  calculateTextOverflow()
}

const prepareCustomizedPlayer = () => {
  playerData.accentColor = customizeData.brandColor
  playerData.showImage = customizeData.showCover

  if (props.customize.isCustomizing) {
    // set playback progress to 50% for a better preview of the progress bar and slider dot
    const newPlaybackPosition = Math.floor(playerData.audioDurationSeconds / 2)
    audioElement.value.currentTime = newPlaybackPosition
    playerData.currentPlaybackTime = newPlaybackPosition
    playerData.sliderTime = newPlaybackPosition
  }

  setTimeout(setWidth, 300)
}

const prepareAudio = (play) => {
  const { query } = router.currentRoute

  if (Object.keys(query).length > 0) {
    Object.entries(query).forEach(([parameter, value]) => {
      switch (parameter) {
        case 'dm': {
          // dark/light theme
          customizeData.theme = value === '1' ? 'dark' : 'light'
          break
        }
        case 'ci': {
          // show/hide cover image
          customizeData.showCover = value === '1'
          break
        }
        case 'bc': {
          // brand color
          customizeData.brandColor = value
          break
        }
        default: {
          break
        }
      }
    })

    prepareCustomizedPlayer()
  }

  audioElement.value.src = playerData.audioFileUrl
  audioElement.value.volume = playerData.volume / 100

  if (play && audioElement.value.paused) {
    audioElement.value.play()
    playerData.paused = false
  }

  playerData.loading = false
}

const loadEpisode = (episode, play = false) => {
  if (episode.playlistId === playlistData.currentEpisode.playlistId) {
    playPause()
  } else {
    if (playlistData.currentEpisode.playlistId && playlistData.currentEpisode.playlistId !== episode.playlistId) {
      const currentPlayingId = playlistData.currentEpisode.playlistId
      playlistData.episodes[currentPlayingId].playing = false
      resetTimers()
      streamTimer.startTimeMinutes = Math.floor(audioElement.value.currentTime / 60)
    }

    if (!episode.playing || (audioElement.value.paused && play)) {
      playerData.title = episode.title
      playerData.podcastName = episode.podcastName
      playerData.image = episode.image
      playerData.episodePageUrl = episode.link
      playerData.podcastPageUrl = `${
        window.location.hostname === 'localhost' ? 'http://localhost:8080' : `https://${window.location.hostname}`
      }/podcast/${episode.podcastId}`
      playerData.audioFileUrl = episode.src
      playerData.audioDurationSeconds = episode.durationSeconds
      playlistData.currentEpisode = episode

      if (playlistData.episodes.length > 0) {
        playlistData.episodes[episode.playlistId].playing = true
      }

      prepareAudio(play)
      calculateTextOverflow()
    }
  }
  playerData.loading = false
}

const playlistEpisodes = ref(null)
const filterEpisodes = debounce(() => {
  playlistData.filteredEpisodes = playlistData.episodes.filter((episode) => {
    episode.open = false

    const searchString = playlistData.searchValue.trim().toLowerCase()
    if (!searchString) {
      playlistEpisodes.value.scrollTop = 0

      return true
    }

    if (searchString?.length < 2) return true

    const titleMatches = episode.title.toLowerCase().includes(searchString)
    const descriptionMatches = options.filters
      .stripHTML(episode.description, false)
      .toLowerCase()
      .includes(searchString)

    if (descriptionMatches) {
      episode.open = true
      const firstHighlightedStringElement = playlistEpisodes.value.querySelector('.highlight')
      const scrollFirstHighlightedStringElementIntoView = () =>
        firstHighlightedStringElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' })

      if (firstHighlightedStringElement?.closest('.playlist-episode')?.classList.contains('info-open')) {
        scrollFirstHighlightedStringElementIntoView()
      } else {
        firstHighlightedStringElement
          ?.closest('.playlist-episode-description')
          ?.addEventListener('transitionend', scrollFirstHighlightedStringElementIntoView, {
            once: true,
          })
      }
    }

    return titleMatches || descriptionMatches
  })
}, 100)

const audioPlaybackPlaying = () => {
  let index = 0
  while (index < playlistData.episodes.length) {
    playlistData.episodes[index].playing = playlistData.episodes[index].src === audioElement.value.src
    index += 1
  }
}

const audioPlaybackEnded = () => {
  const playlistLength = playlistData.episodes.length
  const currentPlayingId = playlistData.currentEpisode.playlistId
  playlistData.episodes[currentPlayingId].playing = false

  if (playlistLength - 1 > currentPlayingId) {
    loadEpisode(playlistData.episodes[currentPlayingId + 1], true)
  }
}

const preparePlaylist = () => {
  let index = 0
  while (index < playlistData.rawEpisodes.length) {
    const episode = {
      title: playlistData.rawEpisodes[index].title,
      description: playlistData.rawEpisodes[index].description,
      image: getEpisodeImageURL(
        playlistData.rawEpisodes[index].image,
        playlistData.rawEpisodes[index].podcast_images.main
      ),
      id: playlistData.rawEpisodes[index].id,
      src: playlistData.rawEpisodes[index].streamUrl,
      durationSeconds: playlistData.rawEpisodes[index].duration,
      link: playlistData.rawEpisodes[index].link,
      podcastName: playlistData.rawEpisodes[index].podcast_title,
      podcastId: playlistData.rawEpisodes[index].podcast_id,
      publishDate: playlistData.rawEpisodes[index].publish_date,
      open: false,
      playing: false,
    }

    playlistData.episodes.push(episode)
    index += 1
  }

  playlistData.episodes = sortByISODateString(playlistData.episodes, 'publishDate', 'desc')
  let playlistId = 0
  while (playlistId < playlistData.episodes.length) {
    playlistData.episodes[playlistId].playlistId = playlistId
    playlistId += 1
  }

  playlistData.sorted = true
  playlistData.filteredEpisodes = playlistData.episodes
  playerData.shouldShow = true
  audioElement.value.addEventListener('playing', audioPlaybackPlaying)
  audioElement.value.addEventListener('ended', audioPlaybackEnded)

  if (playlistData.episodes.length > 0) {
    loadEpisode(playlistData.episodes[0])
  }
}

const volumeChange = () => {
  audioElement.value.volume = playerData.volume / 100
}

const toggleEpisodeInfo = (id) => {
  playlistData.episodes[id].open = !playlistData.episodes[id].open
}

const sliderClick = (event) => {
  if (event.type && event.type === 'click') {
    audioElement.value.currentTime = playerData.sliderTime
  }
}

const sliderDragStart = () => {
  playerCursorState = 'dragging'
}

const sliderDragEnd = () => {
  audioElement.value.currentTime = playerData.sliderTime
  playerCursorState = 'pointer'
}

const forward = (seconds) => {
  const max = playerData.sliderTime + seconds
  if (max < playerData.audioDurationSeconds) {
    playerData.sliderTime += seconds
    audioElement.value.currentTime += seconds
  } else {
    playerData.sliderTime = playerData.audioDurationSeconds
    audioElement.value.currentTime = playerData.audioDurationSeconds
  }
}

const rewind = (seconds) => {
  const min = playerData.sliderTime - seconds
  if (min > 0) {
    playerData.sliderTime -= seconds
    audioElement.value.currentTime -= seconds
  } else {
    playerData.sliderTime = 0
    audioElement.value.currentTime = 0
  }
}

const timeupdate = () => {
  playerData.currentPlaybackTime = audioElement.value.currentTime

  if (playerCursorState !== 'dragging') {
    playerData.sliderTime =
      audioElement.value.currentTime <= playerData.audioDurationSeconds ? audioElement.value.currentTime : 0
  }
}

const endEventListener = () => {
  playerData.paused = true
  trackEpisodeCompleteImpression(props.episode?.id ?? playlistData.currentEpisode.id)

  const currentPlayerTime = audioElement.value.currentTime
  streamTimer.stopTimeMinutes = Math.floor(currentPlayerTime / 60)
  composeStreamImpression(DataType.STREAM)
}

const loopPostTrackingList = () => {
  setTimeout(() => {
    sendTrackingDataList(statisticObjects)

    loopPostTrackingList()
  }, 30000)
}

watch(props, () => {
  if (props.episode) {
    playerData.loading = true
    playerData.title = props.episode.title
    playerData.podcastName = props.episode.podcast_title
    playerData.audioDurationSeconds = props.episode.duration
    playerData.episodePageUrl = props.episode.link
    playerData.podcastPageUrl = `${
      window.location.hostname === 'localhost' ? 'http://localhost:8080' : `https://${window.location.hostname}`
    }/podcast/${props.episode.podcast_id}`
    playerData.image = getEpisodeImageURL(props.episode.image, props.episode.podcast_images.main)
    playerData.shouldShow = true
    playerData.audioFileUrl = props.episode.streamUrl
    prepareAudio()
  }

  if (props.episodes) {
    playerData.loading = true

    if (audioElement.value.playing) {
      audioElement.value.pause()
      playerData.paused = true
    }

    playlistData.episodes = []
    playlistData.currentEpisode = {}
    playlistData.filteredEpisodes = []
    playlistData.rawEpisodes = {}
    playlistData.sorted = false
    playlistData.rawEpisodes = props.episodes
    preparePlaylist()
  }

  if (props.customize.isCustomizing) {
    playerData.sliderTime = 0
    customizeData.theme = props.customize.theme
    customizeData.brandColor = props.customize.brandColor
    customizeData.showCover = props.customize.showCover

    if (audioElement.value.playing) {
      audioElement.value.pause()
      playerData.paused = true
    }

    setTimeout(() => {
      setWidth()
      prepareCustomizedPlayer()
    }, 200)
  }
})

onMounted(() => {
  window.addEventListener('resize', setWidth)
  calculateTextOverflow()
  new ResizeObserver(calculateTextOverflow).observe(episodeInfo.value)
  new ResizeObserver(calculateTextOverflow).observe(episodeTitle.value)
  new ResizeObserver(calculateTextOverflow).observe(podcastName.value)
  resetTimers()
  loopPostTrackingList()
})

onUnmounted(() => {
  sendTrackingDataList(statisticObjects)
  window.removeEventListener('resize', setWidth)
  audioElement.value.removeEventListener('playing')
  audioElement.value.removeEventListener('ended')
})
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/variables';
@import 'assets/scss/base/functions';
@import 'assets/scss/base/mixins';

.afripods-player {
  font-family: Barlow, sans-serif;
}

.player-loading {
  position: relative;
  top: 30px;
  left: 50%;
  display: block;
  width: 200px;
  height: 200px;
  transform: translateX(-50%);
}

#embedplayer ::v-deep {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 300px;
  max-width: 401px;
  background: $color-white;
  border-radius: 4px;
  transition: all $transition-duration ease-in-out;
  transform: translate(-50%, -50%);

  &.playlist {
    top: 0;
    transform: translateX(-50%);
  }

  .player-wrapper {
    position: relative;
    width: 100%;
    height: 223px;
    padding: 25px;
    user-select: none;
    border: 1px solid #eee;
    border-radius: 4px;
  }

  a {
    color: inherit;
  }

  .episode-info {
    display: flex;
    flex: 1;
    padding-bottom: 20px;

    .episode-image {
      position: relative;
      min-width: 64px;
      min-height: 64px;
      cursor: pointer;
      border-radius: 4px;

      img {
        width: 64px;
        height: 64px;
        border-radius: 4px;
        object-fit: cover;
      }
    }

    .episode-text {
      flex: 1;
      max-width: 100%;
      min-height: 55px;
      max-height: 64px;
      padding-top: 10px;
      margin-left: 14px;
      overflow: hidden;

      > div {
        display: inline;
        overflow: hidden;
        white-space: nowrap;

        &.scrolling {
          display: inline-block;
          animation: marquee 25s 4s linear infinite;

          > div {
            display: inline;
          }

          .episode-title {
            margin-right: 25px;
          }
        }
      }

      a {
        font-size: to-rem(18);
        font-weight: 600;
        line-height: 1.2222;
      }

      .podcast-name {
        width: auto;
        margin-right: 8px;
        cursor: pointer;
      }

      .episode-title {
        width: auto;
        cursor: pointer;
      }

      &:hover .scrolling {
        animation-play-state: paused;
      }
    }
  }

  .player-controls {
    display: flex;
    flex-direction: column;
    height: 120px;

    .button-group {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;

      button {
        position: relative;
        padding: 0;
        margin: 0;
        background: transparent;
        border: none;
      }

      .playback-rate-slider {
        position: relative;
        min-width: 36px;

        .playback-rate-slider-wrap {
          position: absolute;
          bottom: 28px;
          z-index: 5;
          width: 300px;
          padding: 0 16px 8px;
          pointer-events: none;
          background: #e5e5e5;
          border-radius: 8px;
          opacity: 0;
          transition: opacity $transition-duration ease-in-out;

          .slider-marks {
            position: relative;
            width: 100%;
            height: 18px;
            cursor: pointer;

            span {
              position: absolute;
              left: 0;
              width: 4px;
              min-width: 25px;
              margin-left: -12.5px;
              font-size: to-rem(10);
              text-align: center;

              &:nth-child(2) {
                left: 12.5%;
              }

              &:nth-child(3) {
                left: 25%;
              }

              &:nth-child(4) {
                left: 37.5%;
              }

              &:nth-child(5) {
                left: 50%;
              }

              &:nth-child(6) {
                left: 62.5%;
              }

              &:nth-child(7) {
                left: 75%;
              }

              &:nth-child(8) {
                left: 87.5%;
              }

              &:nth-child(9) {
                left: 100%;
              }
            }
          }

          .vue-slider {
            .vue-slider-dot {
              width: 5.5px !important;
              height: 5.5px !important;
            }

            .vue-slider-dot-handle {
              box-shadow: none;
            }

            .vue-slider-rail {
              height: 3px;
            }
          }
        }

        #playback-rate {
          position: relative;
          width: auto;
          min-width: 28px;
          height: 28px;
          padding: 0 6px;
          font-size: to-rem(10);
          font-weight: 500;
          line-height: 2;
          background: #e5e5e5;
          border-radius: 50%;
        }

        &:hover {
          .playback-rate-slider-wrap {
            pointer-events: all;
            opacity: 1;
          }
        }
      }

      .volume-slider {
        position: relative;

        #volume {
          position: relative;
          z-index: 5;
          display: block;
          width: 28px;
          height: 28px;
          margin-left: 8px;
          color: $color-black;
          background: #e5e5e5;
          border-radius: 50%;

          svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .volume-slider-wrap {
          @include half-circle;

          position: absolute;
          bottom: 0;
          left: 8px;
          z-index: 1;
          display: block;
          width: 28px;
          height: 28px;
          padding: 10px 0 31px 5px;
          background: #e5e5e5;
          opacity: 0;
          transition-duration: $transition-duration;
          transition-property: width, height, opacity; // stylelint-disable-line

          .vue-slider {
            height: 100% !important;
            opacity: 0;
            transition: opacity $transition-duration;

            .vue-slider-rail {
              width: 3px !important;
            }

            .vue-slider-dot {
              width: 5.5px !important;
              height: 5.5px !important;
            }

            .vue-slider-dot-handle {
              box-shadow: none;
            }
          }
        }

        &:hover {
          .volume-slider-wrap {
            height: 105px;
            opacity: 1;

            .vue-slider {
              opacity: 1;
            }
          }
        }
      }

      .rw-play-fw {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;

        #playPause {
          position: relative;
          width: 49px;
          height: 49px;
          margin: 0 30px;
          color: $color-white;
          background: $color-black;
          border-radius: 50%;
          transition: transform $transition-duration ease-out;
          will-change: transform;

          &:active {
            transition: none;
            transform: scale(0.95);
          }

          svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-5px, -50%);
            will-change: opacity, filter;

            &#pause {
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }

    .player-progress {
      margin-bottom: 25px;

      .sliderwrap {
        flex: 1;
        padding: 0 12px;
      }

      .vue-slider {
        .vue-slider-rail {
          height: 3px;
          cursor: pointer;
          background: #e5e5e5;
        }

        .vue-slider-dot {
          position: relative;
          width: 12px;
          height: 12px;
          cursor: pointer;
          background: rgb(0 0 0 / 20%);
          border-radius: 50%;
          opacity: 0;
          transition: opacity $transition-duration ease-in-out !important;
        }

        .vue-slider-dot-handle {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 6px;
          height: 6px;
          border: none;
          border-radius: 50%;
          box-shadow: none;
          opacity: 0;
          transition: opacity $transition-duration ease-in-out !important;
          transform: translate(-50%, -50%);
        }

        .vue-slider-process {
          transition: 0s !important;
        }

        &:hover {
          .vue-slider-dot {
            opacity: 1;
            transition: opacity $transition-duration ease-in-out !important;

            .vue-slider-dot-handle {
              opacity: 1;
            }
          }
        }
      }

      .timestamps {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-top: 2px;

        span {
          min-width: 27px;
          font-size: to-rem(10);
          font-weight: 500;
          line-height: 1.8;
        }

        .current-playback-time {
          float: left;
          font-weight: 700;
          text-align: right;
        }

        .episode-duration {
          float: right;
          text-align: left;
        }
      }
    }
  }

  .player-logo {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 63px;
    height: 22px;
    font-size: 0;
    cursor: pointer;
    border: 1px solid #eee;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;

    img {
      position: relative;
      top: 1px;
      left: 6px;
      width: 50px;
      height: 12px;
      object-fit: contain;
    }
  }

  #embed {
    display: none;
  }

  .player-wrapper.no-image {
    .player-controls,
    .episode-info {
      padding-left: 0;
    }
  }

  &:not(.preview-mobile) {
    @media (min-width: $screen-sm-min) {
      max-width: 650px;

      .player-wrapper {
        max-height: 120px;
        padding: 0;
      }

      .episode-info,
      .player-controls {
        width: 100%;
        max-width: 766px;
        height: 58px;
        padding-left: 220px;

        .button-group {
          justify-content: start;
          margin-top: -12px;

          .rw-play-fw {
            flex: initial;
            height: 20px;

            button:not(#playPause) {
              height: 28px;
            }

            #playPause {
              position: absolute;
              top: 30px;
              left: 140px;
              width: 60px;
              height: 60px;
              margin: 0;
              color: $color-white;
            }
          }

          button:not(#playPause) {
            margin-right: 10px;
          }

          .volume-slider {
            #volume {
              margin-left: 8px;
            }

            .volume-slider-wrap {
              height: 28px !important;
              padding: 5px 10px 0 31px;

              .vue-slider {
                width: 100% !important;
                height: 3px !important;

                .vue-slider-rail {
                  width: 100% !important;
                }
              }
            }

            &:hover {
              .volume-slider-wrap {
                width: 105px;
              }
            }
          }

          .playback-rate-slider {
            min-width: 46px;
          }
        }

        .player-progress {
          width: calc(100% - 40px);
          margin-bottom: 0;

          .timestamps {
            position: relative;
            justify-content: end;
            padding-top: 8px;

            .sliderwrap {
              position: absolute;
              top: -4px;
              width: 100%;
              padding: 0;
            }

            .episode-duration::before {
              display: inline-block;
              margin: 0 2px;
              content: '/';
            }
          }
        }
      }

      .episode-info {
        padding-bottom: 0;

        .episode-image {
          position: absolute;
          top: 4px;
          left: 4px;
          width: 110px;
          height: 110px;

          img {
            width: 110px;
            height: 110px;
          }
        }

        .episode-text {
          max-width: calc(100% - 46px);
          padding-top: 24px;
          margin-left: 0;

          .episode-title {
            margin-right: 45px;
          }
        }
      }

      .player-wrapper.no-image {
        .player-controls,
        .episode-info {
          padding-left: 110px;
        }

        .button-group .rw-play-fw #playPause {
          left: 30px;
        }
      }
    }

    @media (min-width: 905px) {
      max-width: 810px;

      .player-controls {
        .player-progress {
          width: 100%;
        }
      }

      .episode-info {
        .episode-text {
          max-width: 100%;
        }
      }
    }
  }

  .playlist-wrapper {
    position: relative;
    width: 100%;
    min-width: 300px;
    max-width: 401px;
    height: auto;
    max-height: 465px;
    margin-top: 0;
    overflow: hidden;
    user-select: none;
    border: 1px solid #eee;
    border-radius: 4px;
    transition: all $transition-duration ease-in-out;

    .playlist-title {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 63px;
      padding: 16px 24px;
      background: linear-gradient(
        0deg,
        #d9d9d9 -167.46%,
        rgb(217 217 217 / 47.4%) -94.93%,
        rgb(217 217 217 / 0%) 57.14%
      );
      border-bottom: 1px solid #e5e5e5;

      span {
        font-size: to-rem(18);
        font-weight: 600;
        line-height: 1;
        vertical-align: middle;
      }

      .playlist-search {
        $size: 33px;

        @include half-circle;

        position: absolute;
        top: 16px;
        right: 24px;
        width: $size;
        height: $size;
        color: #7f8a8e;
        background: $color-white;
        border: 1px solid #eee;
        transition: width $transition-duration ease-in-out; // stylelint-disable-line plugin/no-low-performance-animation-properties

        &.expanded,
        &:hover,
        &.has-value {
          width: 252px;

          &.button {
            width: calc(100% - 48px);
          }

          input {
            width: calc(100% - 40px);
          }
        }

        svg {
          position: absolute;
          top: 9px;
          left: 10px;
        }

        input {
          position: absolute;
          top: 6px;
          left: 32px;
          width: 0;
          padding: 0;
          font-size: to-rem(14);
          font-weight: 400;
          line-height: 1.3;
          color: #7f8a8e;
          background: transparent;
          border: none;

          &::-webkit-search-cancel-button {
            display: block;
            width: 12px;
            height: 12px;
            margin-right: 5px;
            cursor: pointer;
            background: url($clear-icon-svg);
          }
        }
      }
    }

    .playlist-episodes {
      height: auto;
      max-height: 362px;
      overflow: hidden;
      overflow-y: auto;

      .playlist-episode {
        width: 100%;
        min-height: 55px;
        padding: 17px 24px 17px 17px;
        border-bottom: 1px solid #e5e5e5;
        transition: all $transition-duration ease;

        &:last-child {
          border: none;
        }

        .playlist-episode-top {
          display: flex;
          gap: 26px;
        }

        .episode-play {
          position: relative;
          width: 24px;
          height: 24px;
          color: $color-white;
          background-color: #e1e1e1;
          border: none;
          border-radius: 50%;
          transition: background-color $transition-duration;

          svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          &.playing {
            background: $color-black;
          }

          &:hover:not(.playing) {
            background: rgb(0 0 0 / 30%);
          }
        }

        .playlist-episode-title {
          display: flex;
          flex: 1;
          flex-direction: column;
          align-items: flex-start;

          span {
            display: inline-block;
            width: auto;
          }

          .title {
            font-size: to-rem(16);
            font-weight: 600;
            line-height: 1.1875;
            user-select: text;
          }
        }

        .show-more {
          position: relative;
          padding-right: 18px;
          font-size: to-rem(12);
          font-weight: 400;
          line-height: 1.6667;
          color: #7f8a8e;
          white-space: nowrap;
          cursor: pointer;

          svg {
            position: absolute;
            top: 50%;
            right: 0;
            transition: transform $transition-duration;
            transform: translateY(-50%);
            transform-origin: top;
          }
        }

        .playlist-episode-duration {
          height: 22px;
          padding: 4px 6px;
          font-size: to-rem(12);
          font-weight: 600;
          line-height: 1.2;
          color: #7a7a7a;
          background: #f4f4f4;
          border-radius: 2px;
        }

        .playlist-episode-description {
          max-width: 600px;
          padding-top: 8px;
          padding-left: 50px;
          overflow: hidden;
          font-size: to-rem(12);
          line-height: 1.5;
          color: #424242;
          text-align: justify;
          user-select: text;

          a {
            color: $color-blue-secondary;
            transition: color $transition-duration;

            &:hover {
              color: $color-blue-secondary-light;
            }
          }
        }

        &.info-open {
          background: #fafafa;

          .show-more {
            svg {
              transform: rotate(90deg);
            }
          }
        }

        .highlight {
          color: $gray-base;
          background-color: $brand-yellow;
        }
      }

      .no-filter-matches {
        padding: 16px 22px;
      }
    }

    &:not(.preview-mobile) {
      @media (min-width: 600px) {
        max-width: 650px;
        max-height: 440px;

        .playlist-episodes {
          .playlist-episode {
            .playlist-episode-title {
              flex-direction: row;
            }

            .show-more {
              margin-left: 8px;
            }
          }
        }
      }

      @media (min-width: 905px) {
        max-width: 810px;
      }
    }
  }
}

.dark-theme {
  #embedplayer ::v-deep {
    color: $color-white;

    .player-wrapper {
      background: $color-nation-dark;
    }

    .player-logo {
      background: $color-white;
      border-color: $color-nation-dark;
    }

    .episode-text,
    .player-controls .player-progress .timestamps {
      color: $color-white;
    }

    .button-group {
      .rw-play-fw {
        #playPause {
          color: $color-nation-dark !important;
          background: $color-white;
        }

        :not(#playPause) {
          svg {
            color: $color-white;
          }
        }
      }

      .playback-rate-slider #playback-rate,
      .volume-slider #volume {
        color: $color-white;
        background: #333;
      }

      .playback-rate-slider,
      .volume-slider {
        .vue-slider {
          .vue-slider-rail {
            background: #767676;
          }
        }
      }

      .playback-rate-slider {
        .playback-rate-slider-wrap {
          color: $color-white;
          background: #333;
        }
      }

      .volume-slider {
        .volume-slider-wrap {
          background: #333;
        }
      }
    }

    .playlist-wrapper {
      border-color: $color-black;

      .playlist-title {
        color: $color-white;
        background: $color-black;
      }

      .playlist-search {
        color: $color-white;
        background: $color-black;
        border-color: $color-white;

        input {
          color: $color-white;

          &::placeholder {
            color: $color-white;
          }

          &::-webkit-search-cancel-button {
            filter: brightness(100);
          }
        }
      }

      .playlist-episodes {
        background: $color-black;

        .playlist-episode {
          color: $color-white;
          border-color: $color-white;

          .show-more {
            color: $color-white;
          }

          &.info-open {
            background: #333;

            .playlist-episode-description {
              color: $color-white;

              a {
                color: #fdd366;
              }
            }
          }

          .playlist-episode-duration {
            color: $color-white;
            background: transparent;
            border: 1px solid $color-white;
          }

          .episode-play {
            background: #686868;

            svg {
              path {
                fill: $color-black;
                stroke: $color-black;
              }
            }

            &:hover {
              background: #aaa;
            }

            &.playing {
              background: $color-white;
            }
          }
        }
      }
    }
  }
}

.customizing {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px auto 0;

  #embedplayer ::v-deep {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
  }
}

@keyframes marquee {
  80%, // causes a brief pause between iterations
    100% {
    transform: translate3d(-50%, 0, 0);
  }
}

// vue <transition> styles
.fade-blur-enter-active,
.fade-blur-leave-active {
  transition-duration: $transition-duration !important;
  transition-property: opacity, filter !important;
}

.fade-blur-enter,
.fade-blur-leave-to {
  filter: blur(2px) !important;
  opacity: 0.25;
}
</style>



// WEBPACK FOOTER //
// EmbedPlayerShell.vue